export const ACCOUNT_STATUS_ANONYMUS = Symbol('ACCOUNT_STATUS_ANONYMUS')
export const ACCOUNT_STATUS_GUARDIAN_INACTIVE = Symbol(
  'ACCOUNT_STATUS_GUARDIAN_INACTIVE'
)
export const ACCOUNT_STATUS_GUARDIAN_ACTIVE = Symbol('ACCOUNT_STATUS_GUARDIAN_ACTIVE')
